import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { useRole } from '../contexts/RoleContext';
import '../styles/Layout.css';
import logo from '../assets/images/allianz-logo.svg';
import userIcon from '../assets/images/user-icon.png';
import DashboardIcon from '@mui/icons-material/Dashboard';

import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import config from '../config'; // Add this import to fix the undefined error

const Layout = ({ children }) => {
    const { instance, accounts } = useMsal();
    const location = useLocation(); // Add this line
    const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
    const userRole = useRole();
    
    // Debug code to check groups
    useEffect(() => {
        if (accounts && accounts.length > 0) {
            const account = accounts[0];
            console.log("LAYOUT DEBUG - User account:", account);
            console.log("LAYOUT DEBUG - idTokenClaims:", account.idTokenClaims);
            console.log("LAYOUT DEBUG - User groups:", account.idTokenClaims?.groups);
            
            // Check if our target groups exist in the list
            const adminGroupId = config.adminGroupId;
            const requestorGroupId = config.requestorGroupId;
            
            const groups = account.idTokenClaims?.groups || [];
            console.log("LAYOUT DEBUG - Is admin group present:", groups.includes(adminGroupId));
            console.log("LAYOUT DEBUG - Is requestor group present:", groups.includes(requestorGroupId));
        }
    }, [accounts]);
    
    // Get current user's info
    const currentUser = accounts && accounts.length > 0 ? accounts[0] : null;
    const userEmail = currentUser?.username || "Not signed in";
    const userName = currentUser?.name || userEmail.split('@')[0];

    const initiateLogout = () => {
        setLogoutDialogOpen(true);
    };

    const confirmLogout = () => {
        setLogoutDialogOpen(false);
        instance.logoutRedirect({
            postLogoutRedirectUri: config.msalRedirectUri, // Now this is defined
        });
    };

    const cancelLogout = () => {
        setLogoutDialogOpen(false);
    };

    return (
        <div className="layout">
            <header className="navbar">
                <Link to="/">
                    <img src={logo} alt="Allianz Logo" className="logo" />
                </Link>
                <nav>
                    <ul>
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/dashboard">Dashboard</Link></li>
                        <li><Link to="/about">About ODM Portal</Link></li>
                        <li><Link to="/support">Need Support?</Link></li>
                        {accounts && accounts.length > 0 && (
                            <li>
                                <button 
                                    onClick={initiateLogout}
                                    style={{
                                        backgroundColor: '#003781',
                                        color: 'white',
                                        border: 'none',
                                        padding: '5px 10px',
                                        borderRadius: '5px',
                                        cursor: 'pointer'
                                    }}
                                >
                                    Logout
                                </button>
                            </li>
                        )}
                        <li style={{ display: 'flex', alignItems: 'center' }}>
                            <img src={userIcon} alt="User Icon" className="user-icon" />
                            {accounts && accounts.length > 0 && (
                                <div style={{ 
                                    marginLeft: '8px', 
                                    display: 'flex',
                                    flexDirection: 'column'
                                }}>
                                    <span style={{ 
                                        fontSize: '14px',
                                        color: '#003781',
                                        fontWeight: 'bold'
                                    }}>
                                        {userEmail}
                                    </span>
                                    <span style={{ 
                                        fontSize: '12px',
                                        color: userRole.isAdmin ? '#d32f2f' : '#2e7d32',
                                        fontWeight: 'bold'
                                    }}>
                                        {userRole.roleName}
                                    </span>
                                </div>
                            )}
                        </li>
                    </ul>
                </nav>
            </header>
            <div className="separator"></div>
            <div className="hero-section">
                <div className="overlay"></div>
            </div>
            <main>{children}</main>
            <footer className="footer">
                <a href="https://www.allianz.com/en/privacy-statement.html" target="_blank" rel="noopener noreferrer">
                    Privacy Notice
                </a>
                &nbsp;|&nbsp;
                <span>© 2025 Allianz</span>
            </footer>

            {/* Logout Confirmation Dialog */}
            <Dialog open={logoutDialogOpen} onClose={cancelLogout}>
                <DialogTitle>Confirm Logout</DialogTitle>
                <DialogContent>
                    <Typography>
                        Are you sure you want to log out {userName}?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={cancelLogout} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={confirmLogout} color="error" variant="contained">
                        Logout
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default Layout;